import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'lib-dialog-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `<div
    class="w-[920px] h-[600px] flex items-center justify-center bg-gray-200"
  >
    <div id="loading"></div>
  </div>`,
  styles: [
    `
      #loading {
        display: inline-block;
        width: 50px;
        height: 50px;
        border: 6px solid rgba(248, 247, 247, 0.8);
        border-radius: 50%;
        border-top-color: #011e41;
        animation: spin 1s ease-in-out infinite;
        -webkit-animation: spin 1s ease-in-out infinite;
      }

      @keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }
      @-webkit-keyframes spin {
        to {
          -webkit-transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class DialogSpinnerComponent {}
